import { render, staticRenderFns } from "./ColorfulPage.vue?vue&type=template&id=add8e07e&scoped=true&"
import script from "./ColorfulPage.vue?vue&type=script&lang=js&"
export * from "./ColorfulPage.vue?vue&type=script&lang=js&"
import style0 from "./ColorfulPage.vue?vue&type=style&index=0&id=add8e07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add8e07e",
  null
  
)

export default component.exports